<div class="formContainer p-8">
    <form [formGroup]="formControl" (ngSubmit)="submitForm()">
        <div class="formColumn">
            <input formControlName="email" placeholder="Email" type="email" [style.border]="formControl.controls.email.touched && !formControl.controls.email.valid ?'1px solid red':''">
            <span *ngIf="error" style="color: red; font-size: 13px;">{{error}}</span>
            <button type="submit" [disabled]="!formControl.valid || loading">Done</button>
        </div>
    </form>
</div>